export function getTimeAgo(
  targetTime: string,
  currentTimeFromProps: string
): string {
  const currentTime:any = currentTimeFromProps
    ? new Date(currentTimeFromProps)
    : new Date();
  // eslint-disable-next-line no-param-reassign
  const newTargetTime:any = new Date(targetTime);
  const timeDifference = currentTime - newTargetTime; // Time difference in milliseconds

  // Calculate seconds ago
  const secondsAgo = Math.floor(timeDifference / 1000);

  if (secondsAgo < 60) {
    // return `${secondsAgo} second${secondsAgo > 1 ? 's' : ''} ago`;
    return `Few seconds ago`;
  }

  // Calculate minutes ago
  const minutesAgo = Math.floor(timeDifference / (1000 * 60));

  if (minutesAgo < 60) {
    return `${minutesAgo} minute${minutesAgo > 1 ? 's' : ''} ago`;
  }

  // Calculate hours ago
  const hoursAgo = Math.floor(timeDifference / (1000 * 60 * 60));

  if (hoursAgo < 24) {
    return `${hoursAgo} hour${hoursAgo > 1 ? 's' : ''} ago`;
  }

  // Calculate days ago
  const daysAgo = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
  return `${daysAgo} day${daysAgo > 1 ? 's' : ''} ago`;
}
